import colors from '../colors';
import styled from 'styled-components';

export default styled.hr`
    height: 0;
    margin: 1em auto;
    border-top: 0;
    border-right: 0;
    border-bottom: 1px solid ${colors.mediumGray};
    border-left: 0;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Divider.tsx